import { render } from "./BankAccountUpdate.vue?vue&type=template&id=25d8df33"
import script from "./BankAccountUpdate.vue?vue&type=script&lang=js"
export * from "./BankAccountUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__